import { Input, InputMasks } from '@ui-components/neo.tax';

import { ValueInputType } from './types';

export const DateValueInput: ValueInputType = ({ onChange, value }): React.ReactElement => (
  <Input
    mask={InputMasks.DATE}
    value={value ?? ''}
    placeholder="mm/dd/yyyy"
    onChange={(value): void => {
      onChange(value);
    }}
  />
);
